export const launchClearanceStatuses = ['GO', 'STANDBY'] as const
export type LaunchClearanceStatus = (typeof launchClearanceStatuses)[number]

export const launchClearanceStatusLabel: Record<LaunchClearanceStatus, string> = {
  GO: 'GO',
  STANDBY: 'Stand-By',
}
